import { axios } from '../config/axios';

const endPoint = '/project/device/hardware-audit';

// Query parameters of the venue screen: exam filters and dropdowns, each a list of the values
// ticked (tpm=2.0&tpm=1.2&amt=Active). Filters with nothing ticked are not sent.
const toVenueAuditParams = ({ examFilters = {}, facetFilters = {} }) => Object.fromEntries(
    Object.entries({ ...examFilters, ...facetFilters }).filter(([, values]) => Array.isArray(values) && values.length)
);
// Several values of one filter as amt=Active&amt=Disabled, which Express reads as a list.
const paramsSerializer = { indexes: null };

// One page of the matching devices of a venue (venueId "all" for every venue), with a count per
// value of each dropdown, the matching count and the total
const getVenueDevices = async (venueId, { page, limit, examFilters, facetFilters }) => {
    return axios.get(`${endPoint}/venues/${venueId}/devices`, {
        params: { page, limit, ...toVenueAuditParams({ examFilters, facetFilters }) },
        paramsSerializer,
    });
}

// The venue screen's filter options: venues, drives, courses, batches, exam dates, labs and the dropdowns
const getVenueDeviceFilters = async (venueId) => {
    return axios.get(`${endPoint}/venues/${venueId}/filters`);
}

const downloadVenueDeviceCsv = async (venueId, { examFilters, facetFilters }) => {
    return axios.get(`${endPoint}/venues/${venueId}/download-csv`, {
        params: toVenueAuditParams({ examFilters, facetFilters }),
        paramsSerializer,
        responseType: 'blob',
        headers: {
            'Cache-Control': 'no-cache'
        }
    });
}

// The hardware to compare a device's current hardware with (id is the device row's id):
// { currentFingerprint, previous, change, basis }, previous null when there is none
const getPreviousHardware = async (id) => {
    return axios.get(`${endPoint}/devices/${id}/previous-hardware`);
}

export { getVenueDevices, getVenueDeviceFilters, downloadVenueDeviceCsv, getPreviousHardware }
